import React, { MouseEvent } from 'react';
import { ButtonHTMLType, ButtonType } from 'antd/lib/button/button';
import { Button as AntButton, Tooltip as AntdTooltip } from 'antd';
export type OnButtonClick = (ev: MouseEvent) => any | Promise<any>;

export interface IBaseButtonProps {
    label?: string;
    tooltip?: string;
    type?: ButtonType;
    size?: 'LARGE' | 'REGULAR' | 'SMALL';
    onClick?: OnButtonClick;
    block?: boolean;
    className?: string;
    loading?: boolean;
    htmlType?: ButtonHTMLType;
    disabled?: boolean;
    hidden?: boolean;
}

export function BaseButton(props: IBaseButtonProps): JSX.Element {

    const getSize = (size: string) => {
        switch (size) {
            case 'LARGE':
                return 'large';
            case 'REGULAR':
                return null;
            case 'SMALL':
                return 'small';
            default:
                return null;
        }
    };

    return (
        <AntdTooltip title={props.tooltip}>
            <AntButton
                type={props.type ? props.type : 'default'}
                htmlType={props.htmlType ? props.htmlType : 'button'}
                size={getSize(props.size)}
                loading={props.loading}
                className={props.className}
                hidden={props.hidden}
                disabled={props.disabled}
                block={props.block}
                onClick={props.onClick}>
                {props.label}
            </AntButton>
        </AntdTooltip>
    );
}
